import { Box } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import React from "react";

function SkeletonLoader() {
  return (
    <Box
      mt="15px"
      bgcolor="#ffffff"
      display="flex"
      justifyContent="space-between"
      width="100%"
      flex={1}
      py={"15px"}
      px={"10px"}
      alignItems="center"
      borderRadius={"10px"}
    >
      <Box display="flex">
        <Skeleton animation="wave" variant="circle" width={70} height={70} />
      </Box>
      {[1, 2, 3].map((item) => (
        <Box
          flex={1}
          display="flex"
          mx="20px"
          borderRadius={5}
          flexDirection="column"
          justifyContent="space-around"
        >
          <Skeleton
            animation="wave"
            variant="rect"
            width={"80%"}
            height={5}
            style={{ margin: "5px 0" }}
          />
          <Skeleton
            animation="wave"
            variant="rect"
            width={"50%"}
            height={5}
            style={{ margin: "5px 0" }}
          />
        </Box>
      ))}

      <Skeleton
        animation="wave"
        variant="rect"
        width={"100px"}
        height={35}
        style={{ borderRadius: 5 }}
      />
    </Box>
  );
}

export default SkeletonLoader;
